import PermissionGate from '../ReusableComponents/PermissionGate';
import React, { useEffect, useRef, useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { FaListAlt, FaPlus, FaVideo } from "react-icons/fa";
import { MdDelete, MdModeEdit, MdPrint } from "react-icons/md";
import { Link, useHistory, useParams } from "react-router-dom";
import Search from "../ReusableComponents/Search";

import { Button, Modal } from "react-bootstrap";
import Request from "../../Request";
import Pagination from '@material-ui/lab/Pagination';
import { BsFillEyeFill } from "react-icons/bs";
import { logout } from "../../actions/AppActions";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";
import ImprimirDiagramacao from "./ImprimirDiagramacao";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";



const Diagramacoes = props => {

    const [lesson_cards, SetLessonCards] = useState(null);
    const [loading_screen, setLoadingScreen] = useState(true);
    const [loading_diagramacoes, setLoadingdiagramacoes] = useState(false);
    const [search_oficial, setSearchOficial] = useState('');

    const [diagramacoes, setdiagramacoes] = useState([]);
    const [pagination, setPagination] = useState({ current_page: 1, last_page: 1 });



    const [search, setSearch] = useState('');
    const { processo_id, processo_name } = props;
    const [show_warning, setShowWarning] = useState(false);
    const [diagramacao_id, setRedacaoId] = useState(null);
    const [diagramacaoSelect, setDiagramacaoSelect] = useState(null);



    const [questaoSelect, setQuestaoSelect] = useState({});

    const [showModal, setShowModal] = useState(false);
    let refs = [];
    const dispatch = useDispatch();
    const location = useLocation();

    const Getdiagramacoes = async (page, search) => {

        let response = await Request.Get(user.role=='viwer'?`faculdade/get_diagramacoes_all?page=${page}&search=${search}`: `faculdade/get_diagramacoes/${processo_id}?page=${page}&search=${search}`);
        console.log(response);
        if (response === undefined) return;
        if (response['message'] == 'Unauthenticated.') {
            dispatch(logout());
            return;
        }
        if (response.pagination.current_page == page) {
            let diagramacao_id = new URLSearchParams(location.search).get('diagramacao_id');
            let diagramacao = [...response.diagramacoes.filter((item,id)=>item.id==diagramacao_id)];

            setdiagramacoes(response.diagramacoes);

            setPagination(response.pagination);
            setLoadingScreen(false);
            setLoadingdiagramacoes(false);
            if(diagramacao.length>0){
                console.log(diagramacao)

                    setDiagramacaoSelect(diagramacao[0]);
                    setShowModal(true);
                    history.push({search:'?tab=2'})

               
            }


        }
    }

    const DeleteRedacao = async (diagramacao_id) => {

        let response = await Request.Delete(`faculdade/delete_diagramacao/${diagramacao_id}`);
        console.log(response);
        if (response === undefined) return;

        if (response['message'] == 'Unauthenticated.') {
            dispatch(logout());
            return;
        }
        Getdiagramacoes(pagination.current_page, search_oficial);



    }

    useEffect(() => {
        Getdiagramacoes(1, search_oficial);
    }, []);
    const user = useSelector(state => state.AppReducer.user);

    let pesquisarTimeout = null;
    const history = useHistory();
    console.log('select', diagramacaoSelect)
    return (
        <div className="row">

            <div className="col-12">
                 <div className={user.role=='viwer'? "card":''}>
                        <div className={user.role=='viwer'? "card-body":''} id="card">

                            {user.role=='viwer' && <h4 className="mt-0 header-title" style={{ fontSize: '1.5rem', color: 'black' }}>Lista de Diagramações</h4>}


                {/* <hr /> */}
                {loading_screen == false && <div>
                    {<p className="text-muted hidethis">Aqui ficam as diagramações {(user.empresa==null || user.empresa.change_text==false)?'do processo':'da vaga/cargo'} "{processo_name}"</p>}

                    {/* <h4 className="mt-0 header-title" style={{ fontSize: '1.2rem', color: 'black', textAlign: 'center' }}>Questões</h4> */}
                    {/* <br /> */}
                    {<div className="hidethis">
                        <div className="flex jcsb flex-wrap mb-4">

                            <Search placeholder="Pesquisar pelo nome da diagramação" ValueChange={value => {
                                clearTimeout(pesquisarTimeout);
                                setSearchOficial(value);

                                pesquisarTimeout = setTimeout(() => {
                                    let page = { ...pagination };
                                    page.current_page = 1;
                                    setPagination(pagination);
                                    setLoadingdiagramacoes(true);

                                    Getdiagramacoes(1, value)

                                }, 500);
                            }} />

                            {user.role!='viwer' && <div style={{ display: 'flex' }}>

                                <PermissionGate module="provas" action="create"><Link to={{
                                    pathname: "/diagramacoes/register/" + processo_id,
                                    // state: {
                                    //     course_id: id
                                    // }
                                }} style={{ textDecoration: "none" }}>
                                    <Button variant="success" className="flex align-center jcc"><FaPlus style={{ marginRight: 10 }} /> <p style={{ margin: 0 }}>Adicionar nova diagramação</p></Button>
                                </Link></PermissionGate>
                            </div>}
                        </div>
                    </div>}


                    <div className="table-rep-plugin hidethis">
                        <div className="table-responsive mb-0" data-pattern="priority-columns">
                            <table id="tech-companies-1" className="table table-striped">
                                <thead>
                                    <tr>

                                        <th>Título</th>
                                        <th>Nome</th>
                                        <th>Número de colunas</th>
                                        <th data-priority="3">Ações</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {loading_diagramacoes == false && diagramacoes.map((item, id) => (

                                        <tr key={id}>
                                            <td>{item.titulo_pagina}</td>
                                            <td>{item.nome_prova}</td>
                                            <td>{item.numero_colunas}</td>
                                            {/* <td><img style={{ height: 60, width: 60, objectFit: 'contain' }} src={STORAGE_URL + STORAGE_URL + item.arquivo} /></td> */}

                                            <td>
                                                 <span
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setShowModal(true);

                                                        setDiagramacaoSelect(item);
                                                    }}
                                                    className="inline-flex align-center jcc bg-success icon"
                                                    style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                                                    title="Imprimir diagramacao"
                                                >
                                                    <MdPrint size={17} color="white" />
                                                </span>
                                                {user.role!='viwer' && <>

                                                <Link to={`/diagramacoes/show/${item.id}`} onClick={(e) => e.stopPropagation()}>

                                                    <span
                                                        onClick={() => {

                                                        }}
                                                        className="inline-flex align-center jcc bg-warning icon"
                                                        style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                                                        title="Gerenciar diagramação"
                                                    >
                                                        <BsFillEyeFill size={17} color="white" />
                                                    </span>
                                                </Link>

                                               
                                                <PermissionGate module="provas" action="edit"><Link to={`/diagramacoes/edit/${item.id}`} onClick={(e) => e.stopPropagation()}>
                                                    <span
                                                        className="inline-flex align-center jcc bg-info icon"
                                                        style={{ width: "2em", height: "2em", borderRadius: "7px", marginRight: "2px", marginLeft: "2px" }}
                                                        data-toggle="tooltip"
                                                        title="Editar diagramação"
                                                    >
                                                        <MdModeEdit color="white" size={17} />
                                                    </span>
                                                </Link></PermissionGate>
                                                <PermissionGate module="provas" action="delete"><span
                                                    onClick={(e) => {
                                                        setRedacaoId(item.id);
                                                        setShowWarning(true);
                                                        e.stopPropagation();
                                                    }}
                                                    className="inline-flex align-center jcc bg-danger icon"
                                                    style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                                                    title="Deletar diagramacao"
                                                >
                                                    <MdDelete size={17} color="white" />
                                                </span></PermissionGate>
                                                </>}

                                            </td>

                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                            {loading_diagramacoes == true &&
                                <div className="row" style={{ margin: 0 }}> <div className="col-12 d-flex justify-content-center align-items-center">
                                    {/* <div className="spinner-border text-primary" role="status"  >
                                    </div> */}
                                    <CircularProgress />
                                </div></div>

                            }
                        </div>
                    </div>
                    {loading_diagramacoes == false && diagramacoes.length == 0 && <div className="row w-100">
                        <div className="col-12">
                            <p style={{ textAlign: 'center' }}>Nenhuma diagramação encontrada</p>

                        </div>
                    </div>}

                    <Pagination
                        className={(pagination.last_page == 1 ? "hide hidethis" : "hidethis ")}
                        style={{ display: "flex", justifyContent: "flex-end" }}
                        count={pagination.last_page}
                        value={pagination.current_page}
                        onChange={(_, value) => {
                            setLoadingdiagramacoes(true);
                            console.log(_, value);
                            let page = { ...pagination };
                            page.current_page = value;
                            setPagination(pagination);
                            Getdiagramacoes(value, search_oficial)
                        }}
                    />
                    <Modal
                        show={showModal == true}
                        dialogClassName="modal_width_full"
                        onHide={() => setShowModal(false)}
                    >
                        <Modal.Header closeButton>
          {/* <Modal.Title>Modal title</Modal.Title> */}
        </Modal.Header>
                        <Modal.Body>
                            {showModal==true && <ImprimirDiagramacao isModal={true} showModal={showModal} setShowModal={(e) => setShowModal(e)} diagramacao={diagramacaoSelect} />}

                        </Modal.Body>

                    </Modal>

                    {/* {this.state.andamento == true && <AvaliacaoAndamento get_diagramacao={this.get_diagramacao.bind(this)} {...this.props} />} */}
                    {/* <ImprimirDiagramacao isModal={false} showModal={showModal} setShowModal={(e) => setShowModal(e)} diagramacao={diagramacaoSelect} /> */}

                </div>}

                {loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                    {/* <div className="spinner-border text-primary" role="status"  >
                    </div> */}
                    <CircularProgress />
                </div></div>}


                <SweetAlert
                    warning
                    title={"Atenção"}
                    onConfirm={() => {
                        setShowWarning(false);
                        setLoadingdiagramacoes(true);
                        DeleteRedacao(diagramacao_id);
                        // this.delete_banner(this.state.banner_to_delete);
                    }}
                    onCancel={() => {
                        setShowWarning(false);
                    }}
                    show={show_warning}
                    confirmBtnText='Sim, desejo apagar'
                    cancelBtnText='Cancelar'
                    confirmBtnBsStyle="success"
                    cancelBtnBsStyle="danger"
                    showCancel={true}
                >
                    Ao deletar esta diagramação, ele não estará mais disponível no sistema
                </SweetAlert>

            </div>
            </div>

            </div>

        </div>
    )
}

export default Diagramacoes;
